/*
 * Public API Surface of admin-service
 */
export default {};
